const { container } = require('@/container');

/**
 * @param {Order} order
 *
 * @return {Promise<void>}
 */
export const addGreekTaxToOrder = async (order) => {
    if (container.eInvoicingService.inUseForCompany()) {
        console.log('Disabling Sign Pro Greek tax line because eInvoicing is in use.');
        order.greekTaxLine = false;
        return;
    }

    if (order.greekTaxLine !== null) {
        // Already loaded (or determined it doesn't need to be loaded).
        console.debug('Greek Tax line already loaded.');
        return;
    }

    // Create the data to add to the receipt for Greek tax.
    let greekTaxRegistration = container.taxManager.getGreekTaxRegistrationCodeFromCompany(
        container.userService.company
    );
    if (!greekTaxRegistration) {
        order.greekTaxLine = false;
        return;
    }

    try {
        order.greekTaxLine = await container.taxManager.getTaxSummaryAndCreateGreekTaxLine(
            order,
            null,
            greekTaxRegistration
        );
    } catch (e) {
        console.warn('Failed to load Greek tax info.', e);
    }
};
